import React, { Component } from 'react';
import getLocale from '../../../i18n/getLocale';

import ScheduleGradeEquipmentChiefAdd from './ScheduleGradeEquipmentChiefAdd';

class ScheduleGradeEquipmentChiefTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      chiefs: this.props.chiefs,
    };

    this.locale = getLocale();

  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.chiefs)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        chiefs: newProps.chiefs,
        types_list: newProps.types_list,
        loaded: 1,
      });
    }
  }
  
  

  render() {
    var self = this;
    return (
<div>
  <h3 className="page-title">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.tituloChefesDeEquipamento}</h3>
  <hr/>
  {(this.state.chiefs === null || typeof this.state.chiefs === 'undefined') ?  <div><small><em>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.nenhumChefeDeEquipamentoDisponIvel}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>     
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.tabela.Tripulante}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.tabela.Matricula}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.tabela.Designacao}</th>
          <th className="col-md-4 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.tabela.AlocarNaEscala}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.chiefs).map(function(k) {
          return (
            <tr>
              <td>{self.state.chiefs[k].staff.name}</td>
              <td className="text-center">{self.state.chiefs[k].staff.inscription}</td>
              <td>{self.state.chiefs[k].designation.name}</td>
              <td>
                <ScheduleGradeEquipmentChiefAdd schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id}  updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} staff_id={self.state.chiefs[k].staff.id} date_start={self.props.date_start} date_finish={self.props.date_finish} types_list={self.props.types_list} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }

</div>
    );
  }
}


export default ScheduleGradeEquipmentChiefTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeEquipmentChiefTab.js